<template>
    <div>
        <ToolBar
            :menu="'Tiếp nhận dữ liệu QLNT'"
            :content="'Báo cáo tình hình nộp dữ liệu'"
            :subContent="'Báo cáo tình hình nộp dữ liệu cấp Trường '"
        >
        </ToolBar>
        <FormSearch :column-form="column_form" :on-enter-search="handleSearch">
            <div class="row">
                <div class="col-md-3 mb-3">
                    <label>Phường/Xã</label>
                    <ESelect
                        :disabled="isRoleEducationOfficeOrSchool"
                        :data="list_ward"
                        :multiple="true"
                        :fields="['tenPhuongXa', 'maPhuongXa']"
                        @change="onChangeWard"
                        v-model="ward"
                    />
                </div>
                <div class="col-md-3 mb-3">
                    <label>Trường học <span class="error-label">*</span></label>
                    <ESelect
                        :disabled="isRoleSchool"
                        :data="list_school"
                        :multiple="true"
                        :fields="['label', 'value']"
                        v-model="school"
                        @input="onChangeHandler('school', $event)"
                        :textError="err_school_label"
                    />
                </div>
                <div class="col-md-3 mb-3">
                    <label>Loại dữ liệu <span class="error-label">*</span></label>
                    <ESelect
                        :data="list_data_type"
                        :fields="['label', 'value']"
                        v-model="data_type"
                        @change="onChangeDataType"
                        @input="onChangeHandler('data_type', $event)"
                        :textError="err_data_type"
                    />
                </div>

                <div class="col-md-3 mb-3 form-search-btn-cell">
                    <CustomButton label="Tìm kiếm" @click="handleSearch" />
                </div>
            </div>

            <div class="form-group">
                <label class="control-label" >
                    Hướng dẫn/ Ghi chú
                    <span class="close-note" @click="toggleNote">
                         <i :class="noteVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </span>
                </label>
                <template v-if="noteVisible">
                    <br />
                    <label class="control-label">
                        <span style="color: red"> (1)</span>
                        Số học sinh tốt nghiệp:
                    </label>
                    <ul class="note-list">
                        <span class="note-item">
                            Mầm non: Số trẻ hoàn thành chương trình mầm non (Dữ liệu
                            nộp học kỳ 2)
                            <br />
                            Tiểu học: Số học sinh được đánh giá hoàn thành chương
                            trình tiểu học (Dữ liệu nộp Học kỳ 2 - Giao đoạn cuối học
                            kỳ 2)
                            <br />
                            THCS,THPT: >Số học sinh được xét tốt nghiệp (Dữ liệu nộp
                            học kỳ cuối năm)
                        </span>
                    </ul>
                </template>
            </div>
        </FormSearch>
        <CustomTable
            :column-form="column_form"
            :hideBtnTable="true"
            :title="'Báo cáo tình hình nộp dữ liệu cấp trường'"
        >
            <template v-slot:title-actions>
                <CustomButton label="Xuất Excel" @click="handleExportExcel" />
            </template>
            <template v-slot:header>
                <tr v-if="data_type === -1">
                    <th
                        v-for="(header, index) in header_data_type_all_1"
                        :key="index"
                        :rowspan="header.rowspan"
                        :colspan="header.colspan"
                        class="min-width"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === -1">
                    <th
                        v-for="(header, index) in header_data_type_all_2"
                        :key="index"
                        :rowspan="header.rowspan"
                        :colspan="header.colspan"
                        class="min-width"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === -1">
                    <th
                        v-for="(header, index) in header_data_type_all_3"
                        :key="index"
                        class="min-width"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === 2">
                    <th
                        v-for="(header, index) in header_data_type_officer"
                        :key="index"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === 3">
                    <th
                        v-for="(header, index) in header_data_type_class_1"
                        :rowspan="header.rowspan"
                        :colspan="header.colspan"
                        :key="index"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === 3">
                    <th
                        v-for="(header, index) in header_data_type_class_2"
                        :key="index"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === 4">
                    <th
                        v-for="(header, index) in header_data_type_student"
                        :key="index"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === 5">
                    <th
                        v-for="(
                            header, index
                        ) in header_data_type_learning_outcomes"
                        :key="index"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === 14">
                    <th
                        v-for="(header, index) in header_data_type_room"
                        :key="index"
                    >
                        {{ header.text }}
                    </th>
                </tr>
                <tr v-if="data_type === 16">
                    <th
                        v-for="(
                            header, index
                        ) in header_data_type_foreign_language_project"
                        :key="index"
                    >
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:body>
             
                <template v-if="data_type === -1">
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>
                            {{ (start / limit) * limit + index + 1 }}
                        </td>
                        <td class="min-width text-left">
                            {{ item.tenTruong }}
                        </td>
                        <td class="text-left">
                            {{ item.maDoiTac }}
                        </td>
                        <td>
                            {{ getGradeLevelText(item.capHoc) }}
                        </td>

                        <td class="text-right">
                            {{ item.dlCanBo.tongSoBanGhiTrenQlnt }}
                        </td>
                        <td class="text-right">
                            {{ item.dlCanBo.tongSoBanGhiDaNop }}
                        </td>
                        <td class="text-center">
                            {{ item.dlCanBo.ngayNopCuoi }}
                        </td>
                        <td class="text-right">
                            {{ item.dlDeAnNgoaiNgu.soGvNgoaiNgu }}
                        </td>
                        <td class="text-right">
                            {{ item.dlDeAnNgoaiNgu.soGvCoQuaTrinhBdncnlnn }}
                        </td>
                        <td class="text-right">
                            {{ item.dlDeAnNgoaiNgu.soGvCoQuaTrinhBdncnlsp }}
                        </td>
                        <td class="text-right">
                            {{ item.dlLopHoc.tongSoBanGhiTrenQlnt }}
                        </td>
                        <td class="text-right">
                            {{ item.dlLopHoc.tongSoBanGhiDaNop }}
                        </td>
                        <td class="text-right">
                            {{ item.dlLopHoc.soLopGhep }}
                        </td>
                        <td class="text-right">
                            {{ item.dlLopHoc.soLopDon }}
                        </td>
                        <td class="text-center">
                            {{ item.dlLopHoc.ngayNopCuoi }}
                        </td>
                        <td class="text-right">
                            {{ item.dlHocSinh.tongSoBanGhiTrenQlnt }}
                        </td>
                        <td class="text-right">
                            {{ item.dlHocSinh.tongSoBanGhiDaNop }}
                        </td>
                        <td class="text-center">
                            {{ item.dlHocSinh.ngayNopCuoi }}
                        </td>
                        <td class="text-right">
                            {{ getNumberOfStudentsBySemester(item.dlKqht, 1) }}
                        </td>
                        <td class="text-right">
                            {{ getNumberOfStudentsBySemester(item.dlKqht, 2) }}
                        </td>
                        <td class="text-right">
                            {{ getNumberOfStudentsBySemester(item.dlKqht, 3) }}
                        </td>
                        <td class="text-right">
                            {{ getGraduatedStudentsCount(item.dlKqht) }}
                        </td>
                        <td class="text-right">
                            {{ getLastSubmissionDate(item.dlKqht) }}
                        </td>
                    </tr>
                </template>
                <template v-if="data_type === 2">
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>
                            {{ (currentPage - 1) * limit + index + 1 }}
                        </td>
                        <td class="min-width text-left">{{ item.tenTruong }}</td>
                        <td class="text-left">{{ item.maDoiTac }}</td>
                        <td class="text-left">
                            {{ getGradeLevelText(item.capHoc) }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoBanGhiTrenQlnt }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoBanGhiDaNopNamTruoc }}
                        </td>
                        <td class="text-right">{{ item.tongSoBanGhiDaNop }}</td>
                        <td class="text-center">{{ item.ngayNopCuoi }}</td>
                    </tr>
                </template>
                <template v-if="data_type === 3">
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>
                            {{ (start / limit) * limit + index + 1 }}
                        </td>
                        <td class="text-left min-width">{{ item.tenTruong }}</td>
                        <td class="text-left">{{ item.maDoiTac }}</td>
                        <td class="text-left">
                            {{ getGradeLevelText(item.capHoc) }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoBanGhiTrenQlnt }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoBanGhiDaNopNamTruoc }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoBanGhiDaNop }}
                        </td>
                        <td class="text-right">
                            {{ item.soLopGhep }}
                        </td>
                        <td class="text-right">
                            {{ item.soLopDon }}
                        </td>
                        <td class="text-center">
                            {{ item.ngayNopCuoi }}
                        </td>
                    </tr>
                </template>
                <template v-if="data_type === 4">
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>
                            {{ (start / limit) * limit + index + 1 }}
                        </td>
                        <td class="text-left">
                            {{ item.maDoiTac }}
                        </td>
                        <td class="text-left min-width">
                            {{ item.tenTruong }}
                        </td>
                        <td class="text-left">
                            {{ getGradeLevelText(item.capHoc) }}
                        </td>

                        <td class="text-right">
                            {{ item.tongSoBanGhiTrenQlnt }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoBanGhiDaNopNamTruoc }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoBanGhiDaNop }}
                        </td>
                        <td class="text-center">
                            {{ item.ngayNopCuoi }}
                        </td>
                    </tr>
                </template>
                <template v-if="data_type === 5">
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>
                            {{ (start / limit) * limit + index + 1 }}
                        </td>
                        <td class="text-left min-width">
                            {{ item.tenTruong }}
                        </td>
                        <td class="text-left">
                            {{ item.maDoiTac }}
                        </td>
                        <td class="text-left">
                            {{ getGradeLevelText(item.capHoc) }}
                        </td>

                        <td class="text-right">
                            {{ item.tongSoBanGhiTrenQlnt }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoHocSinhDaNop }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoBanGhiDaNop }}
                        </td>
                        <td class="text-right">
                            {{ item.tongSoHocSinhTotNghiep }}
                        </td>
                        <td class="text-center">
                            {{ item.ngayNopCuoi }}
                        </td>
                    </tr>
                </template>
                <template v-if="data_type === 14">
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>
                            {{ (start / limit) * limit + index + 1 }}
                        </td>
                        <td class="text-left min-width">
                            {{ item.tenTruong }}
                        </td>
                        <td class="text-left">
                            {{ item.maDoiTac }}
                        </td>
                        <td class="text-left">
                            {{ getGradeLevelText(item.capHoc) }}
                        </td>

                        <td class="text-center">
                            {{ item.ngayNopCuoi }}
                        </td>
                        <td class="text-left">
                            {{ item.kyHieuBieuMau }}
                        </td>
                        <td class="text-left">
                            <div v-html="item.duLieuLoi"></div>
                        </td>
                    </tr>
                </template>
                <template v-if="data_type === 16">
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>
                            {{ (start / limit) * limit + index + 1 }}
                        </td>
                        <td class="text-left min-width">
                            {{ item.tenTruong }}
                        </td>
                        <td class="text-left">
                            {{ item.maDoiTac }}
                        </td>
                        <td class="text-left">
                            {{ getGradeLevelText(item.capHoc) }}
                        </td>

                        <td class="text-right">
                            {{ item.soGvNgoaiNgu }}
                        </td>
                        <td class="text-right">
                            {{ item.soGvCoQuaTrinhBdncnlnn }}
                        </td>
                        <td class="text-right">
                            {{ item.soGvCoQuaTrinhBdncnlsp }}
                        </td>
                        <td class="text-center">
                            {{ item.ngayNopCuoi }}
                        </td>
                    </tr>
                </template>
            </template>
            <template v-slot:pagi>
                <CustomPagination
                    v-show="total_rows > 0"
                    :tongbanghi="total_rows"
                    :pageSize="pageSize"
                    :pageStart="pageStart"
                    @pageChange="pageChange($event)"
                    @pageSizeChange="pageSizeChange($event)"
                >
                </CustomPagination>
            </template>
        </CustomTable>
    </div>
</template>

<script>
import FormSearch from '@/components/FormSearch.vue'
import ToolBar from '@/components/ToolBar.vue'
import CustomButton from '@/components/CustomButton.vue'
import ESelect from '@/components/ESelect.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import { convertListData } from '@/utils'
import { handlerError, validateFields } from '@/utils/validator'

import CustomTable from '@/components/CustomTable.vue'
import CustomPagination from '@/components/CustomPagination.vue'
import {
    list_data_type,
    header_data_type_all_1,
    header_data_type_all_2,
    header_data_type_all_3,
    header_data_type_officer,
    header_data_type_class_1,
    header_data_type_class_2,
    header_data_type_student,
    header_data_type_learning_outcomes,
    header_data_type_room,
    header_data_type_foreign_language_project
} from '@/mock_data/bao-cao-tinh-hinh-nop-du-lieu-cap-truong'
import { ROLES, checkUserRole } from '@/constants/Roles'
import { showNotication } from '@/utils/notification'
export default {
    name: 'DataTransferSchedule',
    components: {
        FormSearch,
        ToolBar,
        CustomButton,
        ESelect,
        CustomTable,
        CustomPagination
    },
    data() {
        return {
            start: 0,
            total_rows: 0,
            currentPage: 1,
            limit: 25,
            pageSize: 25,
            pageStart: false,

            ward: [],
            list_ward: [],
            list_school: [],
            school: [],
            err_school_label: '',

            list_data_type: list_data_type,
            data_type: -1,
            err_data_type: '',

            tableData: [],
            header_data_type_all_1: header_data_type_all_1,
            header_data_type_all_2: header_data_type_all_2,
            header_data_type_all_3: header_data_type_all_3,
            header_data_type_officer: header_data_type_officer,
            header_data_type_class_1: header_data_type_class_1,
            header_data_type_class_2: header_data_type_class_2,
            header_data_type_student: header_data_type_student,
            header_data_type_learning_outcomes:
                header_data_type_learning_outcomes,
            header_data_type_room: header_data_type_room,
            header_data_type_foreign_language_project:
                header_data_type_foreign_language_project,

            noteVisible: true
        }
    },

    methods: {
        pageSizeChange(e) {
            this.pageSize = e.soluong
            this.limit = e.soluong
            this.start = 0
            this.currentPage = 1
            this.handleSearch()
        },
        checkTruocKhiTim() {
            this.pageStart = !this.pageStart
        },
        pageChange(e) {
            this.start = e.start
            this.limit = e.limit
            this.currentPage = e.currentPage
            this.handleSearch()
        },
        toggleNote() {
            this.noteVisible = !this.noteVisible
        },
        onChangeWard() {
            this.school = []
            this.get_list_school()
        },
        onChangeHandler(source, newValue) {
            const errorFields = {
                school: 'err_school_label',
                data_type: 'err_data_type'
            }

            handlerError(this, source, newValue, errorFields)

            if (source in errorFields) {
                handlerError(this, source, newValue, errorFields)

                this.errModal = !!newValue || !!this[errorFields[source]]
            } else {
                this.errModal = !!newValue
            }
        },
        onChangeDataType() {
            this.tableData = []
        },

        async get_list_ward() {
            try {
                const request_data = {
                    start: 0,
                    limit: 9999,
                    maTinhThanh: this.auth_user.ma_so,
                    namHoc: this.selectedYearFromStore
                }

                const response = await sendRequest(
                    Api.app.phuong_xa,
                    null, // GET request uses params, not data
                    this.request_headers,
                    request_data // params for GET request
                )

                this.list_ward = response.rows || []
                
                // After loading wards, pre-select based on ma_don_vi if applicable
                if (this.isRoleEducationOfficeOrSchool && this.auth_user?.ma_don_vi) {
                    this.preselectWardFromMaDonVi(this.auth_user.ma_don_vi)
                }
            } catch (error) {
                console.log(error)
                this.list_ward = []
            }
        },
        
        /**
         * Pre-select ward based on ma_don_vi
         */
        preselectWardFromMaDonVi(ma_don_vi) {
            if (!ma_don_vi || !this.list_ward || this.list_ward.length === 0) {
                return
            }
            
            // Find ward where maPhuongXa matches ma_don_vi
            const foundWard = this.list_ward.find(
                (ward) => ward.maPhuongXa === ma_don_vi || ward.maPhuongXa === String(ma_don_vi)
            )
            
            if (foundWard) {
                // Pre-select the ward (as array since it's multiple select)
                this.ward = [foundWard.maPhuongXa]
                // Trigger school list update if ward is pre-selected
                this.get_list_school()
            }
        },

        async get_list_school() {
            const request_data = {
                capHoc: this.selectedGradeLevelFromStore,
                namHoc: this.selectedYearFromStore,
                maPhuongXaList: this.ward || []
            }

            const response = await sendRequest(
                Api.internal_api.dm_School,
                request_data,
                this.request_headers,
                null
            )
            this.list_school = convertListData(
                response.rows,
                'tenTruongHoc',
                'maTruongHoc'
            )
        },
        getGradeLevelText(e) {
            const capHocMapping = {
                1: 'Tiểu học',
                2: 'THCS',
                3: 'THPT',
                4: 'Nhà trẻ',
                5: 'Mẫu giáo',
                6: 'GDTX',
                45: 'Mầm non',
                12: 'Trường liên cấp TH+THCS',
                13: 'Trường liên cấp TH+THPT',
                23: 'Trường liên THCS+THPT',
                123: 'Trường liên cấp TH+THCS+THPT'
            }

            return capHocMapping[e] || ''
        },
        getNumberOfStudentsBySemester(data, semester) {
            const semesterData = data.find((item) => item.semester === semester)
            return semesterData ? semesterData.totalRecordsSubmitted : ''
        },
        getGraduatedStudentsCount(data) {
            const semesterData = data.find(
                (item) =>
                    item.hocKi >= 1 &&
                    item.hocKi <= 3 &&
                    item.tongSoHocSinhTotNghiep
            )
            return semesterData ? semesterData.tongSoHocSinhTotNghiep : ''
        },
        getLastSubmissionDate(data) {
            const semesterData = data.find(
                (item) => item.hocKi >= 1 && item.hocKi <= 3 && item.ngayNopCuoi
            )
            return semesterData ? semesterData.ngayNopCuoi : ''
        },
        async handleExportExcel() {
            try {
                const fieldsToValidate = [
                    {
                        value: this.school,
                        errorField: 'err_school_label'
                    },
                    {
                        value: this.data_type,
                        errorField: 'err_data_type'
                    }
                ]
                if (validateFields(this, fieldsToValidate)) {
                    const request_data = {
                        maSo: this.auth_user.ma_so,
                        capHocList: this.selectedGradeLevelFromStore,
                        hocKy: this.selectedSemesterFromStore,
                        loaiDuLieu: this.data_type,
                        maDonViList: this.ward || [],
                        maTruongHocList: this.school || [],
                        namHoc: this.selectedYearFromStore,
                        start: this.start,
                        limit: this.limit
                    }

                    const response = await sendRequest(
                        Api.tiep_nhan_du_lieu_QLNT.bao_cao_tinh_hinh_nop_du_lieu
                            .excel_cap_truong,
                        request_data,
                        this.request_headers,
                        null
                    )
                    if (response.rc == 0) {
                        const link = `https://moetdbtest.dtsgroup.com.vn${response.urlContext}`
                        window.open(link, '_blank')
                    } else {
                        showNotication(this, 'error', 'Lỗi tải xuống')
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async handleSearch() {
            try {
                const fieldsToValidate = [
                    {
                        value: this.school,
                        errorField: 'err_school_label'
                    },
                    {
                        value: this.data_type,
                        errorField: 'err_data_type'
                    }
                ]
                if (validateFields(this, fieldsToValidate)) {
                    const request_data = {
                        maSo: this.auth_user.ma_so,
                        capHocList: this.selectedGradeLevelFromStore,
                        hocKy: this.selectedSemesterFromStore,
                        loaiDuLieu: this.data_type,
                        maDonViList: this.ward || [],
                        maTruongHocList: this.school || [],
                        namHoc: this.selectedYearFromStore,
                        start: this.start,
                        limit: this.limit
                    }

                    const response = await sendRequest(
                        Api.tiep_nhan_du_lieu_QLNT.bao_cao_tinh_hinh_nop_du_lieu
                            .cap_truong,
                        request_data,
                        this.request_headers,
                        null
                    )

                    this.total_rows = response.totalRows

                    this.tableData = response.tableData
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch: {
        selectedYearFromStore: function (newVal) {
            if (newVal) {
                this.ward = []
                this.get_list_ward()
            }
        },

        selectedGradeLevelFromStore: function (newVal) {
            if (newVal) {
                this.school = []
                this.get_list_school()
            }
        },
        auth_user: {
            handler(user) {
                if (this.isRoleEducationOfficeOrSchool) {
                    // Pre-select ward based on ma_don_vi
                    this.preselectWardFromMaDonVi(user.ma_don_vi)
                }
                if (this.isRoleSchool) {
                    this.school = user.ma_truong_hoc ? [user.ma_truong_hoc] : []
                }
            },
            immediate: true
        },
        list_ward: {
            handler(newList) {
                // When ward list is loaded, try to pre-select based on ma_don_vi
                if (newList && newList.length > 0 && this.isRoleEducationOfficeOrSchool) {
                    const user = this.auth_user
                    if (user && user.ma_don_vi) {
                        this.preselectWardFromMaDonVi(user.ma_don_vi)
                    }
                }
            },
            immediate: false
        }
    },
    mounted() {
        this.get_list_ward()
        this.get_list_school()
    },

    computed: {
        column_form() {
            let extraColumn = this.err_school_label || this.err_data_type ? 1 : 0
            return this.noteVisible ? 4 + extraColumn : 2 + extraColumn
        },
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },
        selectedGradeLevelFromStore() {
            return this.$store.state.gradeLevel.gradeLevel
        },
        selectedSemesterFromStore() {
            return this.$store.state.semester.semester
        },
        auth_user() {
            return getFromSessionStorage('auth_user')
        },

        isRoleEducationOfficeOrSchool() {
            return (
                checkUserRole(this.auth_user, ROLES.EducationOffice) ||
                checkUserRole(this.auth_user, ROLES.School)
            )
        },
        isRoleSchool() {
            return checkUserRole(this.auth_user, ROLES.School)
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped>
.error {
    margin-top: -20px;
    color: red;
}

.min-width {
    min-width: 180px;
}
.form-group {
    line-height: 20px !important;
    margin-bottom: 0 !important;
}
.control-label {
    font-size: 16px !important;
    font-weight: bold !important;
}
.note-list {
    margin: 0 30px;
}
.note-item {
    font-size: 14px;
}
.close-note {
    color: var(--blue-200);
    font-weight: bold;
    cursor: pointer;
    margin-left: 5px; /* Thêm khoảng cách */
    font-size: 16px; /* Tăng kích thước icon */
}
.close-note:hover {
    color: #0074f2;
}
</style>